module ListView

open Elmish
open Fable.React
open Fable.React.Props
open Fulma

type SelectedList<'t> = {
    items:'t list
    selected : 't option
}

type State<'t> =
| Loading
| List of SelectedList<'t>
| Error of exn

type Msg<'req, 't>=
| Loaded of 'req * ('t list)
| Selected of 't
| Error of 'req * exn

let init load arg =
    Loading,
    Cmd.OfPromise.either
        load
        arg
        (fun r -> Loaded (arg, r))
        (fun e -> Error (arg, e))

let update validate autoselect msg model  =
    match msg, model with
    | Loaded (req, list), List l ->
        if validate req
        then List { l with items = list }, Cmd.Empty
        else model, Cmd.Empty
    | Loaded (_, list), _ ->
        List {
            items = list
            selected =
                match autoselect, list with
                | true, [single] -> Some single
                | _ -> None
        }, Cmd.Empty
    | Selected t, List l -> List { l with selected = Some t}, Cmd.Empty
    | Selected _, _ -> model, Cmd.Empty
    | Error (arg, e), _ ->
        if validate arg
        then State.Error e, Cmd.Empty
        else model, Cmd.Empty

let private dropDownItem<'t when 't : equality> (selected:'t option) onSelected name (item:'t) =
    Dropdown.Item.a 
        [ Dropdown.Item.IsActive (selected.IsSome && selected.Value = item) 
          Dropdown.Item.Props [ OnClick (fun e -> e.preventDefault(); item |> onSelected) ]]
        [ (name item) ]

let dropDownList<'t when 't : equality> (list : 't SelectedList) emptyText onSelected name =
    Dropdown.dropdown 
        [ Dropdown.IsHoverable ] 
        [ Button.button 
            [ Button.OnClick (fun e -> e.preventDefault()) ]
            [ span [ ] [ (list.selected |> Option.map name |> Option.defaultValue emptyText) ]
              Icon.icon [ Icon.Size IsSmall ] [ i [ Class "fas fa-angle-down" ] [] ] 
            ] 
          Dropdown.menu []
            [ Dropdown.content 
                []
                (list.items |> List.map (dropDownItem list.selected onSelected name))
            ]
        ]
